module.exports = __webpack_public_path__ + "assets/img/iphone_screen.632a80d7.png";